import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import Counter from "components/counter/Counter";
import CustomSwitch from "components/form/CustomSwitch";
import { useUserAgentInfo } from "utils/hooks/useUserAgentInfo";
const SearchGuestContent = ({
  initialState,
  onChange
}: {
  initialState?: {
    adultCount: number;
    childCount: number;
    petsAllowed: boolean;
  };
  onChange?: (x: {
    adult: number;
    child: number;
    pets: boolean;
  }) => void;
}) => {
  const t = useTranslations("common");
  const [guestOptions, setGuestOptions] = useState({
    adult: initialState?.adultCount || 0,
    child: initialState?.childCount || 0,
    pets: initialState?.petsAllowed || false
  });
  useEffect(() => {
    setGuestOptions({
      adult: initialState?.adultCount || 0,
      child: initialState?.childCount || 0,
      pets: initialState?.petsAllowed || false
    });
  }, [initialState?.adultCount, initialState?.childCount, initialState?.petsAllowed]);
  const {
    isIOSAndSafari
  } = useUserAgentInfo();
  return <div className={`flex flex-col gap-4 pb-5 ${isIOSAndSafari ? "px-4" : ""}`} data-sentry-component="SearchGuestContent" data-sentry-source-file="SearchGuestContent.tsx">
      <div className='flex items-center justify-between py-[6px]'>
        <div>
          <p className='mb-2 text-sm font-semibold leading-[14px] tracking-[-0.14px] text-[#53535D]'>
            {/* Adults */}
            {t("words.adults")}
          </p>
          <span className='text-sm font-medium leading-[14px] text-[#53535D]'>
            Ages 13 and above
            {/*{t("words.ages13orabove")}*/}
            {/* Ages 13 or above */}
          </span>
        </div>
        <div>
          <Counter key='Adults' isDetailPage={false} value={guestOptions.adult} decrementCounter={() => {
          setGuestOptions(_guestOptions => {
            const updatedG = {
              ..._guestOptions,
              adult: _guestOptions.adult - 1
            };
            if (onChange) {
              onChange(updatedG);
            }
            return updatedG;
          });
        }} incrementCounter={() => {
          setGuestOptions(_guestOptions => {
            const updatedG = {
              ..._guestOptions,
              adult: _guestOptions.adult + 1
            };
            if (onChange) {
              onChange(updatedG);
            }
            return updatedG;
          });
        }} isIncrementDisabled={guestOptions.adult + guestOptions.child >= 20} max={20} data-sentry-element="Counter" data-sentry-source-file="SearchGuestContent.tsx" />
        </div>
      </div>
      <div className='flex items-center justify-between py-[6px]'>
        <div>
          <p className='mb-2 text-sm font-semibold leading-[14px] tracking-[-0.14px] text-[#53535D]'>
            {/* Children */}
            {t("words.children")}
          </p>
          <span className='text-sm font-medium leading-[14px] text-[#53535D]'>
            Ages 12 and under
            {/*{t("words.ages2_12")}*/}
            {/* Ages 2-12 */}
          </span>
        </div>
        <div>
          <Counter key='Children' value={guestOptions.child} decrementCounter={() => {
          setGuestOptions(_guestOptions => {
            const updatedG = {
              ..._guestOptions,
              child: _guestOptions.child - 1
            };
            if (onChange) {
              onChange(updatedG);
            }
            return updatedG;
          });
        }} incrementCounter={() => {
          setGuestOptions(_guestOptions => {
            const updatedG = {
              ..._guestOptions,
              child: _guestOptions.child + 1
            };
            if (onChange) {
              onChange(updatedG);
            }
            return updatedG;
          });
        }} isIncrementDisabled={guestOptions.adult + guestOptions.child >= 20} max={20} data-sentry-element="Counter" data-sentry-source-file="SearchGuestContent.tsx" />
        </div>
      </div>
      <div className='flex items-center justify-between'>
        <div>
          <p className='mb-2 text-sm font-semibold leading-[14px] tracking-[-0.14px] text-[#53535D]'>
            {/* Pets */}
            {t("words.pets")}
          </p>
          <span className='text-sm font-medium leading-[14px] text-[#53535D]'>
            {t("words.arepetsallowed")}
            {/* Are pets allowed? */}
          </span>
        </div>
        <div role='button' tabIndex={0} onClick={e => {
        e.stopPropagation(); // Prevent click from toggling the accordion if it is within the switch area
      }} onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation(); // Prevent key press from toggling the accordion
        }
      }}>
          <CustomSwitch id='Pets' checked={guestOptions.pets} onChange={() => {
          setGuestOptions(_guestOptions => {
            const updatedG = {
              ..._guestOptions,
              pets: !_guestOptions.pets
            };
            if (onChange) {
              onChange(updatedG);
            }
            return updatedG;
          });
        }} data-sentry-element="CustomSwitch" data-sentry-source-file="SearchGuestContent.tsx" />
        </div>
      </div>
    </div>;
};
export default SearchGuestContent;